module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.item) ? _c('div', {
    staticClass: "component-vehicle-status"
  }, [(_vm.showToolTip) ? _c('div', {
    staticClass: "row align-middle align-center"
  }, [(_vm.odometer) ? _c('tooltip', {
    staticClass: "has-tip",
    attrs: {
      "open": true,
      "position": 'right',
      "tip": ("Odometer: " + (_vm.item.odometer) + (_vm.configuration.locale.locale_distance_unit.value))
    }
  }, [_c('span', {
    staticClass: "fa fa-dashboard fa-lg"
  }), _c('span', {
    staticClass: "label fuelStatus"
  }, [_vm._v(_vm._s(_vm.item.odometer) + _vm._s(_vm.configuration.locale.locale_distance_unit.value))])]) : _vm._e(), _c('tooltip', {
    staticClass: "has-tip",
    attrs: {
      "open": true,
      "position": 'right',
      "tip": 'Fuel type: ' + _vm.item.fuel_type
    }
  }, [_c('span', {
    staticClass: "fa fa-bolt fa-lg",
    class: _vm.fuelLevel()
  }), _c('span', {
    staticClass: "label fuelStatus"
  }, [_vm._v(_vm._s(_vm.fuelStatus()))])]), _c('tooltip', {
    staticClass: "has-tip",
    attrs: {
      "open": true,
      "position": 'right',
      "tip": 'Door: ' + _vm.item.door_status
    }
  }, [_c('span', {
    class: _vm.doorStatus(_vm.item.door_status)
  })]), _c('tooltip', {
    staticClass: "has-tip",
    attrs: {
      "open": true,
      "position": 'right',
      "tip": 'Engine: ' + _vm.item.engine_status
    }
  }, [_c('span', {
    staticClass: "fa fa-car fa-lg",
    class: _vm.status(_vm.item.engine_status)
  })]), _c('tooltip', {
    staticClass: "has-tip",
    attrs: {
      "open": true,
      "position": 'right',
      "tip": _vm.item.vehicle_slot_hidden ? 'Hidden on map' : 'Visible on map'
    }
  }, [_c('span', {
    staticClass: "fa fa-lg",
    class: _vm.visibility(_vm.item.vehicle_slot_hidden)
  })]), _c('span', {
    staticClass: "has-tip"
  }, [_c('span', {
    staticClass: "fa fa-product-hunt fa-lg",
    class: _vm.inRange(),
    on: {
      "click": _vm.openDetail
    }
  })])], 1) : _vm._e(), (_vm.showDetail) ? _c('div', {
    staticClass: "position-detail"
  }, [_c('div', {
    staticClass: "close-button",
    on: {
      "click": function($event) {
        _vm.showDetail = false
      }
    }
  }, [_vm._v("x")]), _c('GoogleMapContainer', [_c('GoogleMap', {
    attrs: {
      "api-key": _vm.mapsAPI,
      "center": {
        lat: _vm.item.position.latitude,
        lng: _vm.item.position.longitude
      },
      "zoom": 17,
      "zoomControl": true
    }
  }, [_c('google-map-marker', {
    key: _vm.item.plate,
    attrs: {
      "position": {
        lat: _vm.item.position.latitude,
        lng: _vm.item.position.longitude
      },
      "title": ((_vm.item.brand) + " " + (_vm.item.model)),
      "label": ((_vm.item.brand) + " " + (_vm.item.model))
    }
  })], 1)], 1)], 1) : _vm._e(), (_vm.showToolTip === false) ? _c('div', {
    staticClass: "row align-middle align-center"
  }, [_c('span', {
    staticClass: "fa fa-dashboard fa-lg"
  }), _c('span', {
    staticClass: "label fuelStatus"
  }, [_vm._v(_vm._s(_vm.item.odometer) + _vm._s(_vm.configuration.locale.locale_distance_unit.value))]), _c('span', {
    staticClass: "fa fa-bolt fa-lg",
    class: _vm.fuelLevel()
  }), _c('span', {
    staticClass: "label fuelStatus"
  }, [_vm._v(_vm._s(_vm.fuelStatus()))]), _c('span', {
    class: _vm.doorStatus(_vm.item.door_status)
  }), _c('span', {
    staticClass: "fa fa-car fa-lg",
    class: _vm.status(_vm.item.engine_status)
  })]) : _vm._e()]) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-c23fd8b8!./~/vue-loader/lib/template-loader.js?raw&engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/structure/ui/VehicleStatus.vue
// module id = 2676
// module chunks = 1